import { SearchConsoleData } from '../types';

export interface SearchConsoleRequest {
  startDate: string;
  endDate: string;
  dimensions: string[];
  rowLimit?: number;
  startRow?: number;
  dataState?: string;
  dimensionFilterGroups?: {
    filters: {
      dimension: string;
      operator: string;
      expression: string;
    }[];
  }[];
}

export const fetchSearchConsoleData = async (
  siteUrl: string,
  request: SearchConsoleRequest
): Promise<SearchConsoleData[]> => {
  const response = await fetch('/api/gsc/data', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      siteUrl,
      ...request,
      rowLimit: request.rowLimit || 5000,
      startRow: request.startRow || 0,
    }),
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch Search Console data: ${response.statusText}`);
  }

  const data = await response.json();
  
  console.log('Search Console API Response:', data);
  console.log('Request dimensions:', request.dimensions);
  
  if (!data.rows) {
    return [];
  }

  // Transform API response to our data structure
  return data.rows.map((row: any, rowIndex: number) => {
    if (rowIndex < 3) { // Log first few rows for debugging
      console.log(`Row ${rowIndex}:`, row);
    }
    const result: SearchConsoleData = {
      query: '',
      clicks: row.clicks || 0,
      impressions: row.impressions || 0,
      ctr: row.ctr || 0,
      position: row.position || 0,
    };

    // Map dimensions to values
    request.dimensions.forEach((dimension, index) => {
      if (dimension === 'query') {
        result.query = row.keys[index];
      } else if (dimension === 'page') {
        result.page = row.keys[index];
      }
    });

    return result;
  });
};

export const formatDateForAPI = (date: Date): string => {
  return date.toISOString().split('T')[0];
};